import { render, staticRenderFns } from "./MybidDetail.vue?vue&type=template&id=1ae96398&scoped=true"
import script from "./MybidDetail.vue?vue&type=script&lang=js"
export * from "./MybidDetail.vue?vue&type=script&lang=js"
import style0 from "./MybidDetail.vue?vue&type=style&index=0&id=1ae96398&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae96398",
  null
  
)

export default component.exports